<div class="slInputWrap">
	<input pInputText #inputElement
		[id]="widget.uid"
		[hisDdKey]="widget.label"
		[hisDdSearchCriterion]="true"
	    [(ngModel)]="widget.value"
	    [type]="widget.type"
	    (input)="inputChange(widget.value)"
		class="calendarWidth100"/>
	    
<!-- It is not possible to search with operators at p-calendar -->
<!-- So we decided to use in the first step pInputText -->
<!-- and in the next step to add a datepicker in any way -->

<!-- styleClass, locale, dateFormat, showIcon, placeholder etc. -->
<!-- are set by his-calendar.directive -->

<!-- In the generic search we use dataType="string" -->
<!-- because this is what the generic search backend expects -->
	<p-calendar
	    class="hidden-p-inputtext"
	    [readonlyInput]="true"
	    [(ngModel)]="calendarValue"
	    dataType="string"
	    (ngModelChange)="calendarChange()"
	    appendTo="body"
	    [tabindex]="-1">
	</p-calendar>
</div>
